import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { endSupportSession } from '../api/endpoints';
import { getSupportSessionId } from '../api/support';
import { toast } from './toast';
import { useSession } from './session';

/** Фиолетовая плашка режима поддержки и напоминание о незавершённой сессии. */
export function SupportBar() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { me, mode, switchSupport } = useSession();

  const end = useMutation({
    mutationFn: (id: string) => endSupportSession(id),
    onSettled: async () => {
      await switchSupport(null);
      navigate('/admin/users');
    },
    onSuccess: () => toast(t('support.ended')),
  });

  if (me.support) {
    return (
      <div className="support" role="status">
        <span>
          <b>{t('support.barTitle')}</b> {t('support.barText', { name: me.name, reason: me.support.reason })}
        </span>
        <button
          type="button"
          className="btn btn-sm"
          disabled={end.isPending}
          onClick={() => end.mutate(me.support!.session_id)}
        >
          {t('support.end')}
        </button>
      </div>
    );
  }

  const active = me.active_support_session;
  if (mode === 'admin' && active && !getSupportSessionId()) {
    return (
      <div className="notice" role="status">
        <span>{t('support.resumeText', { name: active.target.name, reason: active.reason })}</span>
        <span style={{ display: 'flex', gap: 8 }}>
          <button
            type="button"
            className="btn btn-sm"
            onClick={async () => {
              await switchSupport(active.id);
              navigate('/');
            }}
          >
            {t('support.resume')}
          </button>
          <button
            type="button"
            className="btn btn-sm btn-quiet"
            disabled={end.isPending}
            onClick={() => end.mutate(active.id)}
          >
            {t('support.end')}
          </button>
        </span>
      </div>
    );
  }
  return null;
}
